export default [
  { name: 'Starter', fee: 600, fullname: 'Premium Offsite SEO Starter', code: 'premiumStarter' },
  { name: 'Plus', fee: 1000, fullname: 'Premium Offsite SEO Plus', code: 'premiumPlus' }
]



// WEBPACK FOOTER //
// ./src/data/premiumSEOItems.js